module.exports = __webpack_public_path__ + "static/media/laioffer-course-3.e0bfd8ea.jpg";